import React from 'react';
import { IconProps } from '.';

const SvgArrowBottom = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M4.47 8.53 12 16.06l7.53-7.53-1.06-1.06L12 13.94 5.53 7.47 4.47 8.53ZM4 20.25h16v-1.5H4v1.5Z'
      />
    </svg>
  );
};

export default SvgArrowBottom;
